//RUTAS CUBIERTAS PERSONAL
//--gam
export const urlGetPersonalTyres = "/api/pv/tyre";
export const urlCreatePersonalTyres = "/api/pv/tyre";
export const urlEditPersonalTyres = "/api/pv/tyre";